export const injectionKeys = {
  fluent: Symbol('fluent')
}
